import policies from '../../data/legalPolicies.json';

export const CONSENT_KEY = 'bezalel_privacy_preferences';
export const POLICY_VERSION = policies.version;
export const essentials = { necessary: true, analytics: false, marketing: false };
export function readConsent(storage, now = Date.now()) {
  try {
    const value = JSON.parse(storage.getItem(CONSENT_KEY));
    if (!value || value.version !== POLICY_VERSION || value.necessary !== true || typeof value.analytics !== 'boolean' || typeof value.marketing !== 'boolean' || !Number.isFinite(value.expiresAt) || value.expiresAt <= now) return null;
    return value;
  } catch { return null; }
}
export function createConsent(choices, now = Date.now()) {
  return { necessary: true, analytics: choices.analytics === true, marketing: choices.marketing === true, version: POLICY_VERSION, savedAt: new Date(now).toISOString(), expiresAt: now + 180 * 24 * 60 * 60 * 1000 };
}
// Integrations must consult this guard before loading an optional script.
export function categoryAllowed(consent, category, now = Date.now()) {
  return category === 'necessary' || (!!consent && consent.version === POLICY_VERSION && consent.expiresAt > now && ['analytics', 'marketing'].includes(category) && consent[category] === true);
}
